<div class="dialog-container">
  <div mat-dialog-title>
    {{ 'Groups.Management.Dialog.Contacts.Title' | translate: locale.language }}
    @if (showUserTypeSelection) {
      <small style="float: right">
        <mat-button-toggle-group [value]="selectedUserType" (change)="onUserTypeChange($event.value)">
          <mat-button-toggle value="All">
            {{ 'Groups.Management.Dialog.Contacts.All' | translate: locale.language }}
          </mat-button-toggle>
          <mat-button-toggle value="Internal">{{ 'Internal' | translate: locale.language }}</mat-button-toggle>
          <mat-button-toggle value="Public">{{ 'Public' | translate: locale.language }}</mat-button-toggle>
        </mat-button-toggle-group>
      </small>
    }
  </div>
  <div mat-dialog-content class="dialog-content">
    <div class="search-container">
      <mat-form-field appearance="outline" style="width: 100%">
        <mat-label>
          {{ 'Groups.Management.Contacts.Search' | translate: locale.language }}
        </mat-label>
        <input matInput [formControl]="searchControl" />
      </mat-form-field>
      <mat-progress-bar *ngIf="isLoading" mode="indeterminate" style="margin-bottom: 1rem"></mat-progress-bar>
      <mat-chip-set class="selected-chip-set">
        <mat-chip disabled *ngIf="selected.selected.length === 0">
          {{ 'Groups.Management.Dialog.Contacts.NoneSelectedChip' | translate: locale.language }}
        </mat-chip>
        <mat-chip
          *ngFor="let contactId of selected.selected"
          [removable]="true"
          (removed)="onSelectionChange(idToContact.get(contactId))"
          [matTooltip]="getFirstEmail(idToContact.get(contactId))">
          {{ idToContact.get(contactId)?.firstName }} {{ idToContact.get(contactId)?.lastName }}
          <button
            matChipRemove
            [attr.aria-label]="
              'Remove ' + idToContact.get(contactId)?.firstName + ' ' + idToContact.get(contactId)?.lastName
            "
            [tabIndex]="0">
            <mat-icon>cancel</mat-icon>
          </button>
        </mat-chip>
      </mat-chip-set>
    </div>

    <div class="table-container">
      <mat-table [dataSource]="availableContacts">
        <ng-container matColumnDef="name">
          <mat-header-cell *matHeaderCellDef>
            <mat-checkbox
              (change)="onToggleAll()"
              [indeterminate]="areSomeSelected && !areAllSelected"
              [checked]="areAllSelected"
              [matTooltip]="'Groups.Management.Dialog.Contacts.SelectAll' | translate: locale.language"
              (keydown.enter)="onToggleAll()"
              [aria-label]="'Select all contacts'">
              {{ 'Groups.Management.Contacts.Name' | translate: locale.language }}
            </mat-checkbox>
          </mat-header-cell>
          <mat-cell *matCellDef="let contact">
            <mat-checkbox
              [checked]="isSelected(contact)"
              (change)="onSelectionChange(contact)"
              (keydown.enter)="onSelectionChange(contact)"
              [aria-label]="contact.firstName + ' ' + contact.lastName">
              {{ contact.firstName }} {{ contact.lastName }}
            </mat-checkbox>
          </mat-cell>
        </ng-container>
        <ng-container matColumnDef="email">
          <mat-header-cell *matHeaderCellDef>
            {{ 'Groups.Management.Contacts.Email' | translate: locale.language }}
          </mat-header-cell>
          <mat-cell *matCellDef="let contact">{{ getFirstEmail(contact) }}</mat-cell>
        </ng-container>
        <mat-header-row *matHeaderRowDef="displayedColumns; sticky: true"></mat-header-row>
        <mat-row *matRowDef="let contact; columns: displayedColumns"></mat-row>
      </mat-table>
      <mat-hint style="margin: 1rem" *ngIf="!totalContactCount && !isLoading">
        {{ noContactsText }}
      </mat-hint>
    </div>

    <div class="bottom-container">
      <mat-paginator
        [pageSizeOptions]="[5, 10, 25, 100]"
        [pageSize]="defaultPageSize"
        [length]="totalContactCount"
        (page)="onPageChange($event)"
        [ngClass]="{ hidden: !totalContactCount }"></mat-paginator>
    </div>
  </div>

  <div class="right" mat-dialog-actions>
    <button mat-button mat-dialog-close>
      {{ 'Close' | translate: locale.language }}
    </button>
    <button
      mat-raised-button
      color="primary"
      [disabled]="!selected.selected.length"
      [mat-dialog-close]="selectedContacts">
      {{ addContactsText }}
    </button>
  </div>
</div>
